import { render, staticRenderFns } from "./KpiItem2021.vue?vue&type=template&id=a44b0040&scoped=true&slot=header&"
import script from "./KpiItem2021.vue?vue&type=script&lang=js&"
export * from "./KpiItem2021.vue?vue&type=script&lang=js&"
import style0 from "./KpiItem2021.vue?vue&type=style&index=0&id=a44b0040&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44b0040",
  null
  
)

export default component.exports